import * as React from 'react';

export const LoyaltySymbol = () => (
  <svg
    style={{ minWidth: 16 }}
    width="16"
    height="16"
    viewBox="6.5 3 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M14.5 3L20.1569 5.34315L22.5 11L20.1569 16.6569L14.5 19L8.84315 16.6569L6.5 11L8.84315 5.34315L14.5 3Z"
        fill="url(#paint0_linear_19467_6773)"
      />
      <path
        d="M14.5 3L20.1569 5.34315L22.5 11L20.1569 16.6569L14.5 19L8.84315 16.6569L6.5 11L8.84315 5.34315L14.5 3Z"
        fill="url(#paint1_linear_19467_6773)"
      />
      <path
        d="M9.22583 5.72583L14.5 3.5412L19.7742 5.72583L21.9588 11L19.7742 16.2742L14.5 18.4588L9.22583 16.2742L7.0412 11L9.22583 5.72583Z"
        stroke="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_19467_6773"
        x1="13.9"
        y1="3"
        x2="10.3"
        y2="18.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.222169" stopColor="#CF78A5" />
        <stop offset="0.927169" stopColor="#8695CA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_19467_6773"
        x1="13.1"
        y1="10.6"
        x2="23.3"
        y2="9.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DFB6D0" stopOpacity="0" />
        <stop offset="1" stopColor="#DFB6D0" />
      </linearGradient>
    </defs>
  </svg>
);
